/* eslint-disable jsx-a11y/alt-text */
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";
import Download from "../components/icons/download";
import Logo from "../components/icons/logo";
import Copy from "../components/icons/copy";
import { mousewheel } from "../App";

const SHOW_COPY_TEXT_TIME = 500;
const COLOR_CODE = "#3d31ff";

const Section9 = ({ onSlideChange }) => {
  const [isCopyComplete, setIsCopyComplete] = useState(false);

  const handleCopyColor = () => {
    setIsCopyComplete(true);

    const textarea = document.createElement("textarea");
    textarea.value = COLOR_CODE;
    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    setTimeout(() => {
      setIsCopyComplete(false);
    }, SHOW_COPY_TEXT_TIME);
  };

  return (
    <Swiper
      className="introduce"
      direction="vertical"
      slidesPerView="auto"
      mousewheel={mousewheel}
      nested
      freeMode
      preventInteractionOnTransition
      updateOnWindowResize
      modules={[FreeMode, Mousewheel]}
      onSlideChange={onSlideChange}
    >
      <SwiperSlide style={{ height: "fit-content" }}>
        <div className="asset_box">
          <div className="container asset_container">
            <div className="text_wrap">
              <p className="asset_title animated_text">
                브랜드 에셋
                <br />
                다운로드 받기
              </p>
              <p className="asset_desc animated_text delay">
                락앤락은 브랜드 자산이 일관성 있게
                <br />
                사용될 수 있도록 리소스와 가이드라인을
                <br />
                제공합니다.
              </p>
              <a
                className="download_all"
                href="https://www.locknlock.com/kor/image/common/about/brand/Brand_All.zip"
                download="brand_all.zip"
              >
                전체 다운로드 받기
              </a>
            </div>
            <div className="assets">
              <div className="asset">
                <p className="label">브랜드 로고</p>
                <label className="brand_toggle">
                  <input type="checkbox" className="toggle_check" />
                  <div className="toggle_item">Light</div>
                  <div className="toggle_item">Dark</div>
                </label>
                <Logo />
                <a
                  className="download"
                  href="https://www.locknlock.com/kor/image/common/about/brand/Brand_Logo.zip"
                  download="brand_logo.zip"
                >
                  <Download stroke="#508cff" />
                  다운로드
                </a>
              </div>
              <div className="asset">
                <p className="label">브랜드 슬로건</p>
                <p className="slogan">Lockin’ Your Moment</p>
                <a
                  className="download"
                  href="https://www.locknlock.com/kor/image/common/about/brand/Brand_Slogan.zip"
                  download="brand_slogan.zip"
                >
                  <Download stroke="#508cff" />
                  다운로드
                </a>
              </div>
              <div className="asset bg_image">
                <picture className="brand_bg">
                  <source
                    srcSet="//www.locknlock.com/kor/image/common/about/brand/img_asset_brand_bg_pc.png"
                    media="(min-width: 768px)"
                  />
                  <img src="//www.locknlock.com/kor/image/common/about/brand/img_asset_brand_bg_mob.png" />
                </picture>
                <div className="content_wrap">
                  <p className="label">브랜드 이미지</p>
                  <a
                    className="download"
                    href="https://www.locknlock.com/kor/image/common/about/brand/Brand_Image.zip"
                    download="brand_images.zip"
                  >
                    <Download stroke="#fff" />
                    다운로드
                  </a>
                </div>
              </div>
              <div className="asset bg_blue">
                <p className="label">
                  브랜드 컬러
                  <button className="color_copy">
                    <Copy />
                    <p className="mob_text" onClick={handleCopyColor}>
                      컬러코드 복사{isCopyComplete ? " 완료" : ""}
                    </p>
                    <div className="copy_cover_wrap" onClick={handleCopyColor}>
                      <p className="text">
                        컬러코드 복사{isCopyComplete ? " 완료" : ""}
                      </p>
                    </div>
                  </button>
                </p>
                <p className="info">
                  {COLOR_CODE}
                  <br />
                  R:61 G:49 B:255
                  <br />
                  C:88 M:73 Y:0 K:0
                  <br />
                  Pantone 2728C
                </p>
                <a
                  className="download"
                  href="https://www.locknlock.com/kor/image/common/about/brand/Brand_Color.zip"
                  download="brand_colors.zip"
                >
                  <Download stroke="#fff" />
                  다운로드
                </a>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  );
};

export default Section9;
